import * as React from "react";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { connect } from "react-redux";
import { getProductsDataView } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography from "@insite/mobius/Typography";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link from "@insite/mobius/Link";
import DataTable, { DataTableProps, SortOrderOptions } from "@insite/mobius/DataTable";
import DataTableBody, { DataTableBodyProps } from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell, { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import DataTableHead from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow from "@insite/mobius/DataTable/DataTableRow";
import Button from "@insite/mobius/Button";
import { useState } from "react";
import { AttributeTypeModel } from "@insite/client-framework/Types/ApiModels";
import { getCuttingToolCurrentPageState } from "@theStellarBlueprint/Store/Data/CuttingToolPagination/CuttingToolPaginationSelector";

interface OwnProps {
    categoryId?: string;
    attributeValueIds: string[];
    getCurrentPage: {
        cuttingToolPageNumber: number,
        cuttingToolPageSize: number
    }
}

const mapStateToProps = (state: ApplicationState, Props: OwnProps) => {
    const productsByCategory = getProductsDataView(state, {
        categoryId: Props.categoryId,
        applyPersonalization: true,
        expand: ["attributes", "facets"],
        includeAttributes: ["includeOnProduct"],
        includeSuggestions: true,
        sort: "1",
        page: Props.getCurrentPage.cuttingToolPageNumber,
        pageSize: Props.getCurrentPage.cuttingToolPageSize,
        attributeValueIds: Props.attributeValueIds,
    });

    return {
        products: productsByCategory,
    };
};

export interface AttributesDropdownStyles {
    attributesValueContainer?: InjectableCss;
    gridContainer?: GridContainerProps;
    gridItem?: GridItemProps;
    img?: LazyImageProps;
    dataTable?: DataTableProps;
    prodContainer?: InjectableCss;
    dataTableCell?: DataTableCellProps;
    dataTableBody?: DataTableBodyProps;
    productNumber?: InjectableCss;
    attributeValues?: InjectableCss;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

export const attributeStyles: AttributesDropdownStyles = {
    attributesValueContainer: {
        css: css`
            margin-top: 28px;
            overflow: auto;
        `,
    },
    gridContainer: {
        gap: 28,
        css: css`
            padding: 40px 0px;
            justify-content: space-between;
            > div[class^="GridOffset"] {
                justify-content: center;
                max-width: 100%;
                margin-left: 2px;
            }
        `,
    },
    gridItem: {
        css: css`
            flex-basis: 30%;
            max-width: 30%;
            border: 1px solid #cccccc;
            margin: 0px 14px 28px 14px !important;
        `,
    },
    img: {
        css: css`
            width: 100%;
            height: 250px;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        `,
    },
    prodContainer: {
        css: css`
            width: 100%;
        `,
    },
    dataTable: {
        css: css`
            border: 1px solid #ccc;
        `,
    },
    dataTableCell: {
        css: css`
            border-bottom: none !important;
            padding: 4px;
        `,
    },
    dataTableBody: {
        css: css`
            border-bottom: 1px solid #cccccc;
            padding: 12px 0px;
        `,
    },
    productNumber: {
        css: css`
            margin: 0 !important;
            padding: 4px;
            font-weight: bold;
        `,
    },
    attributeValues: {
        css: css`
            padding: 5px;
        `,
    },
};

const styles = attributeStyles;

const DisplayProducts: React.FC<Props> = ({ products }) => {
    const [view, setView] = useState(true);

    const productstAttributes = products.value;
    const productstAttributesValues = productstAttributes?.map(o => o.attributeTypes?.map(o => o));
    const attributeName: any | undefined = productstAttributesValues?.map(o => o?.map(a => a.name));
    const attributeFacets = products.value && products["attributeTypeFacets"];
    return (
        <StyledWrapper data-test-selector="productsAttributeContainer">
            {/* <StyledWrapper>
                {products.value ? (
                    <Button variant="primary" onClick={() => setView(!view)}>
                        {view === true ? "Table View" : "Inventory View"}
                    </Button>
                ) : null}
            </StyledWrapper> */}
            {/* {view === true ? ( */}
            <StyledWrapper {...styles.attributesValueContainer}>
                <DataTable {...styles.dataTable}>
                    <DataTableHead>
                        {products?.value && attributeFacets && <DataTableHeader>{"Product Number"}</DataTableHeader>}
                        {products.value &&
                            attributeFacets?.map(att => (
                                <DataTableHeader key={att.attributeTypeId}>{att.nameDisplay}</DataTableHeader>
                            ))}
                    </DataTableHead>
                    <DataTableBody>
                        {productstAttributes &&
                            attributeFacets &&
                            productstAttributes.length > 0 &&
                            productstAttributes?.map((value, index) => {
                                return (
                                    <DataTableRow key={value.id}>
                                        <DataTableCell>
                                            <Link href={value.canonicalUrl}>
                                                <Typography variant="p" {...styles.productNumber}>
                                                    {value.productNumber}
                                                </Typography>
                                            </Link>
                                        </DataTableCell>
                                        {attributeFacets?.map((attr, i) => {
                                            const findI: number | undefined = value?.attributeTypes?.findIndex(
                                                function (attributeType) {
                                                    return attributeType.name === attr.nameDisplay;
                                                },
                                            );
                                            const attributeArr: any[] | undefined = value?.attributeTypes;
                                            const attributeObj =
                                                attributeArr && findI !== undefined ? attributeArr[findI] : undefined;
                                            return attributeObj ? (
                                                <DataTableCell key={attr.attributeTypeId}>
                                                    {attributeObj?.attributeValues?.map(
                                                        (attrValue: { valueDisplay: string }, attrIndex: number) => {
                                                            return attrValue.valueDisplay;
                                                        },
                                                    )}
                                                </DataTableCell>
                                            ) : (
                                                <DataTableCell key={attr.attributeTypeId}>-</DataTableCell>
                                            );
                                        })}
                                    </DataTableRow>
                                );
                            })}
                    </DataTableBody>
                </DataTable>
            </StyledWrapper>
            {/* ) : (
                <GridContainer {...styles.gridContainer}>
                    {products.value &&
                        products.value?.map(p => (
                            <GridItem {...styles.gridItem}>
                                <StyledWrapper {...styles.prodContainer}>
                                    <LazyImage src={p.mediumImagePath} {...styles.img} />
                                    <Typography variant="p">
                                        {p.productNumber} - {p.productTitle}
                                    </Typography>
                                    {p.brand && <Typography>{p.brand.name}</Typography>}
                                    <Typography variant="h4">{p.unitListPriceDisplay}</Typography>
                                    <Link href={p.canonicalUrl}>View Product</Link>
                                </StyledWrapper>
                            </GridItem>
                        ))}
                </GridContainer>
            )} */}
        </StyledWrapper>
    );
};

export default connect(mapStateToProps)(DisplayProducts);
